export const baseUrl = '/rest';
export const authUrl = `${baseUrl}/auth`;
export const adminUrl = `${baseUrl}/admin`;
